import React, {createContext, useContext, useMemo, useRef} from 'react'

// @ts-ignore this is inlined from https://raw.githubusercontent.com/kevinparkerson/postmonger/master/postmonger.js
import Postmonger from './postmonger.js'

// TODO
export type PostMongerConnection = any

type PostMongerContextType = {
  connection: PostMongerConnection
}

const PostMongerContext = createContext<PostMongerContextType | undefined>(
  undefined
)

type PostMongerProviderProps = {
  children: React.ReactNode
}

export const PostMongerProvider = ({children}: PostMongerProviderProps) => {
  const connectionRef = useRef<PostMongerContextType>(undefined)

  if (!connectionRef.current) {
    connectionRef.current = new Postmonger.Session()
  }

  const value = useMemo(
    () => ({
      connection: connectionRef.current
    }),
    []
  )

  return (
    <PostMongerContext.Provider value={value}>
      {children}
    </PostMongerContext.Provider>
  )
}

export const usePostMonger = () => {
  const ctx = useContext(PostMongerContext)
  if (!ctx) {
    throw new Error('usePostMonger must be used within a PostMongerProvider')
  }
  return ctx
}
